import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProfileOptionsWrapper from "@pages/Dashboard/ProfileOptions/ProfileOptionsWrapper";

const MobileDrawer = ({
  isOpen,
  onClose,
  manageLanguageSlide,
  onLanguageSlideToggle,
  onLanguageChange,
  onManageToggle,
  props,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const menuItems = [
    { path: "/", label: "Home" },
    { path: "/courses", label: "All courses" },
    { path: "/bundles", label: "All Bundles" },
    { path: "/business", label: "Enterprise" },
    { path: "/teachers", label: "Teach with yslearn.in" },
    { path: "/pricing", label: "Pricing" },
    { path: "/languisity", label: "Languisity", className: "languisity" },
  ];

  return (
    <div className="slideMenu">
      <nav id="sidebar">
        <div className="closemenu" onClick={onClose}>
          <div>
            <i className="icon check"></i>
          </div>
        </div>

        <div className="sidebarMenu">
          <div className="sidebarLink">
            <div className="sidebarSubmenu">
              <ul>
                {menuItems?.map((item) => (
                  <li key={item.path}>
                    <Link
                      onClick={onManageToggle}
                      to={item.path}
                      className={item.className}
                    >
                      {t(item.label)}
                    </Link>
                  </li>
                ))}

                <li>
                  <a
                    href="https://blog.yslearn.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("Blog")}
                  </a>
                </li>

                <li className="slideLang" onClick={onLanguageSlideToggle}>
                  {t("Language")}
                  {manageLanguageSlide && (
                    <ul className="sidebarMultiLanguage">
                      {/* Same language list as LanguageSelector */}
                    </ul>
                  )}
                </li>
                {props.loggedIn && (
                  <ProfileOptionsWrapper link="dashboard" label="Dashboard" />
                )}
                {!props.loggedIn && (
                  <div className="login-signup-button-mobile">
                    <li className="menu-color">
                      <Link
                        onClick={onManageToggle}
                        className="login-btn"
                        to="/login"
                      >
                        {t("Login")}
                      </Link>
                    </li>
                    <li className="menu-color">
                      <Link
                        onClick={onManageToggle}
                        className="registerbtn"
                        to="/register"
                      >
                        {t("Signup")}
                      </Link>
                    </li>
                  </div>
                )}
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default MobileDrawer;
